import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { DietaryFilterProvider } from './contexts/DietaryFilterContext';
import { useAuth } from './hooks/useAuth';
import MainLayout from './components/Layout/MainLayout';
import AuthPage from './components/Auth/AuthPage';
import { OnboardingFlow } from './components/Onboarding';
import HomeView from './components/Home/HomeView';
import ProductsView from './components/Products/ProductsView';
import BrandProfileView from './components/Products/BrandProfileView';
import RecipesView from './components/Recipes/RecipesView';
import DashboardView from './components/Dashboard/DashboardView';
import ProfileView from './components/Profile/ProfileView';
import GroceryListHub from './components/GroceryLists/GroceryListHub';
import SharedListView from './components/GroceryLists/SharedListView';
import PantryHub from './components/Pantry/PantryHub';
import CareProfilesHub from './components/CareProfiles/CareProfilesHub';
import PrivacyPolicyView from './components/Legal/PrivacyPolicyView';
import AboutView from './components/Legal/AboutView';
import ContactView from './components/Legal/ContactView';
import ComingSoonView from './components/ComingSoonView';
import BetaPage from './components/Beta/BetaPage';
import FavoriteProductsView from './components/Products/FavoriteProductsView';

const COMING_SOON = true;

const AppRoutes = () => {
  const { user, loading } = useAuth();

  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F3EF]">
      <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-[#2D5F4D]" />
    </div>
  );

  const showComingSoon = COMING_SOON && !user;

  return (
    <Routes>
      {showComingSoon ? (
        <>
          <Route path="/"           element={<ComingSoonView />} />
          <Route path="/beta"       element={<BetaPage />} />
          <Route path="/onboarding" element={<OnboardingFlow />} />
          <Route element={<MainLayout />}>
            <Route path="/login"  element={<AuthPage />} />
            <Route path="/signup" element={<Navigate to="/login" replace />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </>
      ) : (
        <>
          <Route path="/" element={
            user ? <Navigate to="/home" replace /> : <Navigate to="/login" replace />
          } />

          <Route element={<MainLayout />}>
            <Route path="/login"      element={<AuthPage />} />
            <Route path="/signup"     element={<OnboardingFlow />} />
            <Route path="/onboarding" element={<OnboardingFlow />} />
            <Route path="/home"               element={<HomeView />} />
            <Route path="/products"           element={<ProductsView />} />
            <Route path="/brands/:businessId" element={<BrandProfileView />} />
            <Route path="/recipes"            element={<RecipesView />} />
            <Route path="/recipes/:recipeId"  element={<RecipesView />} />
            <Route path="/dashboard"          element={<DashboardView />} />
            <Route path="/profile"            element={<ProfileView />} />
            <Route path="/grocery-lists"      element={<GroceryListHub />} />
            <Route path="/lists/:shareToken"  element={<SharedListView />} />
            <Route path="/pantry"             element={<PantryHub />} />
            <Route path="/care-profiles"      element={<CareProfilesHub />} />
            <Route path="/favorites"          element={<FavoriteProductsView />} />
            <Route path="/about"              element={<AboutView />} />
            <Route path="/contact"            element={<ContactView />} />
            <Route path="/privacy"            element={<PrivacyPolicyView />} />
            <Route path="/beta"               element={<BetaPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </>
      )}
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <DietaryFilterProvider>
        <Router>
          <AppRoutes />
        </Router>
      </DietaryFilterProvider>
    </AuthProvider>
  );
}

export default App;